import { createSelector } from 'reselect';
import { cultureOnlineEventsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const cultureOnlineEventsYearsSelector = createSelector([cultureOnlineEventsSelector], (cultureOnlineEvents) =>
  extractDatesFromNestedItems(
    [cultureOnlineEvents.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
